import React from 'react'
import { Row, Col, Card, CardTitle } from 'reactstrap'
import { LineLoader } from '@components/content-loader' // 👈️ Content Loader from components

const CustomDataDisplayChart = ({data, loading}) => {

  const mainColors = ['#4261b8', '#78AEFF', '#F74D52', '#a61fad', '#8BD742', '#BCC1C8']

  const typeData = data.unitsPerType.map(el => {
    return {
      name : el.type || el.yard,
      total: el.total
    }
  })

  const yardData = data.unitsPerYard.map(el => {
    return {
      name : el.type || el.yard,
      total: el.total
    }
  })

  const GraphLegend = ({data}) => {
    
    const padding = data.length > 2 ? 4 : 8

    return (
    <div className=''>
    {data.map((el, i) => <p className="mb-1 border-bottom ps-5 fw-bold" 
    style={{borderLeft:`5px solid ${mainColors[i + 1]}`, padding:`${padding}px`}} key={i}>{el.name}: {loading ? <LineLoader foregroundColor={'#eaeced'} backgroundColor={"#eaeced"} /> : `${el.total} Units`} </p>
    )}
    </div>)
  }
    
return (
  <Row>
    <Col md='6' sm='12'>
      <Card className='p-2 h-100'>
        <CardTitle tag='h4'>Units per Type</CardTitle>
        <GraphLegend data={typeData} />
      </Card>
    </Col>
    <Col md='6' sm='12'>
      <Card className='p-2 h-100'>
        <CardTitle tag='h4'>Units per Yard</CardTitle>
        <GraphLegend data={yardData} />
      </Card>
    </Col>
  </Row>
)
}

export default CustomDataDisplayChart